import isEmpty from 'lodash/isEmpty';
import { useTemplateContext } from 'modules/campaigns/editor/context';
import { WebPushPrimaryContent } from 'modules/campaigns/editor/types';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { LightText, StyledNewTabLink } from '../Sections.styled';

export const WebPushContent = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent = {} } = templateAndContent;
  const { message: webPushMessage, icon, title } = primaryContent as WebPushPrimaryContent;
  return (
    <>
      <CampaignFormField labelText="Title">
        <ReadOnlyField name="title">{title || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Body">
        <ReadOnlyField name="message">
          {webPushMessage || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Icon">
        <ReadOnlyField name="icon">
          {!isEmpty(icon) ? (
            <StyledNewTabLink href={icon ?? ''}>{icon}</StyledNewTabLink>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>
    </>
  );
};
